function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgActivityAssetDetached = function SvgActivityAssetDetached(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.89 22.89"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v22.89h22.89V0Zm16.82 17.26H6.07v-2h10.75Zm0-4.82H6.07v-2h10.75Zm0-4.82H6.07v-2h10.75Z",
    "data-name": "Layer 1",
    style: {
      fill: "#4ea5b5"
    }
  })));
};
export default SvgActivityAssetDetached;